import React, {useEffect, useState, useRef} from 'react';
import { Parking } from '../../types/parking';
import { getParkingByName } from '../../services/Administracion/parkingsService';

interface ParkingModalProps {
    parking: Parking;
    onClose: () => void;
    onSave: (parking: Parking) => void;
}

const ParkingModal: React.FC<ParkingModalProps> = ({parking, onClose, onSave}) => {
    const [parkingName, setParkingName] = useState<string>('');
    const [location, setLocation] = useState<string>('');
    const [isActive, setIsActive] = useState<boolean>(true);
    const [isFormValid, setIsformValid] = useState<boolean>(false);
    const [errors, setErrors] = useState<{ parkingName?: string; parkingLocation?: string }>({});
    const parkingNameInputRef = useRef<HTMLInputElement>(null);
    const locationInputRef = useRef<HTMLTextAreaElement>(null);

    const handleSave = () => {
        onSave({...parking, parking_name: parkingName, location, is_active: isActive});
    }

    useEffect(() => {
        if(parking.parking_id){
            setParkingName(parking.parking_name);
            setLocation(parking.location || '');
            setIsActive(parking.is_active);
            setErrors({});
        }
        if(!parking.parking_id && parkingNameInputRef.current){
            parkingNameInputRef.current.focus();
        } else if(parking.parking_id && locationInputRef.current) {
            locationInputRef.current.focus();
        }
    },[parking]);

    useEffect(() => {
        const validarErrores = 
            parkingName.trim() !== '' && 
            (!errors.parkingName || errors.parkingName === '') &&
            (!errors.parkingLocation || errors.parkingLocation === '');
        setIsformValid(validarErrores);
    },[parkingName, isActive, errors]);

    const validateParkingName = async (parkingName: string) => {
        console.log('Validando nombre del parqueo: ', parkingName);
        try {
            const existinParking = await getParkingByName(parkingName);
            if(existinParking.parking_id) {
                return {
                    isValid: false,
                    errorMessage: `El parqueo ${existinParking.parking_name} YA existe` 
                }
            }
            return { isValid: true, errorMessage: ''};
        } catch (error: any) {
            if(error.response.status !== 404) {
                return {
                    isValid: false,
                    errorMessage: error.message || 'Error validando el nombre del parqueo'
                }
            }
        }
    }
    const validateField = async(fieldName: string, value: string) => {
        let errorMessage = '';
        if(value.trim() === ''){
            errorMessage = `Este campo es requerido`
        }
        setErrors((prevErrors) => ({...prevErrors, [fieldName]: errorMessage}));
        if(fieldName === 'parkingName' && value.trim() !== '') {
            const validation = await validateParkingName(value);
            if(!validation?.isValid) {
                setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: validation?.errorMessage}));
            } else {
                setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: '' }));
            }
        }
    };

    return (
        <div className="modal show d-block" tabIndex={-1} role='dialog'>
            <div className="modal-dialog modal-dialog-centered" role='document'>
                <div className="modal-content shadow-lg bg-light">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {parking.parking_id ? 'Editar' : 'Crear'} Parqueo ({parking.parking_id})
                        </h5>
                        <button type='button' className="btn-close" aria-label='Close' onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label htmlFor='parkingName'>Nombre del Parqueo</label>
                            <input 
                                type="text"
                                className={`form-control ${errors.parkingName ? 'is-invalid' : ''}`}
                                id='parkingName'
                                disabled={!!parking.parking_id}
                                value={parkingName}
                                ref={parkingNameInputRef}
                                onBlur={e => validateField('parkingName', e.target.value)}
                                onChange={(e) => {
                                    setParkingName(e.target.value);
                                }}
                            />
                            <div className="invalid-feedback">{errors.parkingName}</div>
                        </div>
                        <div className='form-group'>
                            <label htmlFor="location">Ubicación</label>
                            <textarea 
                                className={`form-control ${errors.parkingLocation ? 'is-valid': ''}`} 
                                id="location"
                                value={location}
                                onChange={(e) => {
                                    setLocation(e.target.value)
                                    validateField('parkingLocation', e.target.value);
                                }}
                                ref={locationInputRef}
                            />
                        </div>
                        <div className='form-check'>
                            <input
                                type='checkbox'
                                className='form-check-input'
                                id='isActive'
                                checked={isActive}
                                onChange={(e) => setIsActive(e.target.checked)}
                            />
                            <label className='form-check-label' htmlFor='isActive'>
                                Activo
                            </label>
                        </div>
                        <div className='modal-footer'>
                            <button type='button' className='btn btn-secondary' onClick={onClose}>
                                Cancelar
                            </button>
                            <button type='button' className='btn btn-primary' onClick={handleSave} disabled={!isFormValid}>
                                Guardar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}

export default ParkingModal;